export type KpiValueType =
  | "number"
  | "percentage"
  | "currency"
  | "text"
  | "duration";

export type KpiTrend = "up" | "down" | "neutral";

export type KpiStatus = "positive" | "negative" | "neutral";

/** Internationalized label - can be a plain string or an object with language keys */
export type I18nLabel = string | { en?: string; pt?: string; es?: string };

/** Resolves an I18nLabel to a display string based on the given language */
export function resolveI18nLabel(
  label: I18nLabel | undefined,
  lang: string,
): string {
  if (!label) return "";
  if (typeof label === "string") return label;
  const langKey = lang as keyof typeof label;
  return label[langKey] || label.en || "";
}

export interface KpiTrendData {
  value: number | string;
  trend: KpiTrend;
  trendValue: string;
  status: KpiStatus;
}

export type ComparisonPeriod =
  | "previous_day"
  | "previous_week"
  | "previous_month";

export interface KpiItem {
  id: string;
  label: I18nLabel;
  value: number | string;
  valueType: KpiValueType;
  trend?: KpiTrend;
  trendValue?: string;
  trendLabel?: string;
  comparison?: string;
  status: KpiStatus;
  icon?: string;
  description?: I18nLabel;
  metadata?: Record<string, unknown>;
  trends?: Partial<Record<ComparisonPeriod, KpiTrendData>>;
}

export interface KpiCategory {
  id: string;
  label: I18nLabel;
  kpis: KpiItem[];
}

export interface KpiSummary {
  label: I18nLabel;
  value: number | string;
  valueType: KpiValueType;
}

export interface KpiDashboardData {
  agentName: string;
  lastUpdatedAt: string;
  categories: KpiCategory[];
  summary?: KpiSummary;
}

export interface KpiPanelProps {
  isOpen: boolean;
  onClose: () => void;
  isDarkTheme: boolean;
  isSidebarCollapsed: boolean;
  useMock: boolean;
  wsData?: KpiDashboardData;
}
